export interface Meridian {
  a: string
  n: string
  l: string
  f: string
}

export const MERIDIANS: Meridian[] = [
  { a: 'Lu', n: 'Lung', l: 'Hand', f: 'Tai Yin' },
  { a: 'LI', n: 'Large Intestine', l: 'Hand', f: 'Yang Ming' },
  { a: 'St', n: 'Stomach', l: 'Foot', f: 'Yang Ming' },
  { a: 'Sp', n: 'Spleen', l: 'Foot', f: 'Tai Yin' },
  { a: 'Ht', n: 'Heart', l: 'Hand', f: 'Shao Yin' },
  { a: 'SI', n: 'Small Intestine', l: 'Hand', f: 'Tai Yang' },
  { a: 'UB', n: 'Urinary Bladder', l: 'Foot', f: 'Tai Yang' },
  { a: 'Kd', n: 'Kidney', l: 'Foot', f: 'Shao Yin' },
  { a: 'PC', n: 'Pericardium', l: 'Hand', f: 'Jue Yin' },
  { a: 'TW', n: 'Triple Warmer', l: 'Hand', f: 'Shao Yang' },
  { a: 'GB', n: 'Gall Bladder', l: 'Foot', f: 'Shao Yang' },
  { a: 'Liv', n: 'Liver', l: 'Foot', f: 'Jue Yin' },
]

export const BAL: Record<string, Record<string, string>> = {
  Lu: { s1: 'Sp', s2: 'UB', s3: 'LI', s4: 'UB', s5: 'Liv' },
  LI: { s1: 'St', s2: 'Liv', s3: 'Lu', s4: 'Kd', s5: 'St' },
  St: { s1: 'LI', s2: 'PC', s3: 'Sp', s4: 'PC', s5: 'LI' },
  Sp: { s1: 'Lu', s2: 'SI', s3: 'St', s4: 'TW', s5: 'Ht' },
  Ht: { s1: 'Kd', s2: 'GB', s3: 'SI', s4: 'GB', s5: 'Sp' },
  SI: { s1: 'UB', s2: 'Sp', s3: 'Ht', s4: 'Liv', s5: 'UB' },
  UB: { s1: 'SI', s2: 'Lu', s3: 'Kd', s4: 'Lu', s5: 'SI' },
  Kd: { s1: 'Ht', s2: 'TW', s3: 'UB', s4: 'LI', s5: 'PC' },
  PC: { s1: 'Liv', s2: 'St', s3: 'TW', s4: 'St', s5: 'Kd' },
  TW: { s1: 'GB', s2: 'Kd', s3: 'PC', s4: 'Sp', s5: 'GB' },
  GB: { s1: 'TW', s2: 'Ht', s3: 'Liv', s4: 'Ht', s5: 'TW' },
  Liv: { s1: 'PC', s2: 'LI', s3: 'GB', s4: 'SI', s5: 'Lu' },
}

export const SYS_LABEL: Record<string, string> = {
  s1: 'Sys 1',
  s2: 'Sys 2',
  s3: 'Sys 3',
  s4: 'Sys 4',
  s5: 'Sys 5',
}

export const SYS_CLS: Record<string, string> = {
  s1: 'sp1',
  s2: 'sp2',
  s3: 'sp3',
  s4: 'sp4',
  s5: 'sp5',
}

export function getMer(a: string): Meridian | null {
  return MERIDIANS.find((m) => m.a === a) || null
}

export function balancersOf(sick: string): Record<string, string[]> {
  const r: Record<string, string[]> = {}
  Object.keys(BAL).forEach((mer) => {
    Object.keys(BAL[mer]).forEach((sk) => {
      if (BAL[mer][sk] === sick) {
        if (!r[mer]) r[mer] = []
        r[mer].push(sk)
      }
    })
  })
  return r
}

export interface Cover {
  sick: string
  sys: string[]
}

export interface CandidateResult {
  mer: string
  n: number
  ts: number
  covers: Cover[]
  misses: string[]
}

export function compute(list: string[]): CandidateResult[] {
  const bm: Record<string, Record<string, string[]>> = {}
  list.forEach((s) => {
    bm[s] = balancersOf(s)
  })

  const cands: Record<string, boolean> = {}
  Object.keys(bm).forEach((s) => {
    Object.keys(bm[s]).forEach((c) => {
      cands[c] = true
    })
  })

  const res = Object.keys(cands).map((cand) => {
    const covers: Cover[] = []
    const misses: string[] = []

    list.forEach((sick) => {
      if (bm[sick][cand]) {
        covers.push({ sick: sick, sys: bm[sick][cand] })
      } else {
        misses.push(sick)
      }
    })

    const ts = covers.reduce((s, c) => s + c.sys.length, 0)
    return {
      mer: cand,
      n: covers.length,
      ts: ts,
      covers: covers,
      misses: misses,
    }
  })

  res.sort((a, b) => {
    return b.n !== a.n ? b.n - a.n : b.ts - a.ts
  })

  return res
}
